import {ProblemCollectionPreview} from '@types';
import {
    OptionType,
    OptionTypeWithLabel,
} from '@components/ux/ProblemCollection/functions/types';

export const transformData = (
    data: ProblemCollectionPreview[],
    getColorFor: (item: ProblemCollectionPreview) => string
): OptionTypeWithLabel[] => {
    const groupedData: {
        [key: string]: OptionType[];
    } = {};

    data.forEach(item => {
        if (!groupedData[item.group]) {
            groupedData[item.group] = [];
        }
        groupedData[item.group].push({
            label: `${item.name}`,
            value: `${item.id}`,
            color: getColorFor(item),
            core: item.core,
        });
    });

    return Object.keys(groupedData).map(group => ({
        label: group,
        options: groupedData[group],
    }));
};
